import { useAppSelector } from '../store/hooks'
import { filterActions } from '../store/filterSlice'
import { useAppStore } from '../store/hooks'
import CardHitComponent from './CardHitComponent'
import { useCallback } from 'react'
import classNames from 'classnames'
import type { BaseHit } from 'instantsearch.js'
import { _x } from '@wordpress/i18n'
import { t } from '../../../../assets/utils/algolia/algoliaLocalization'
import SearchEasterEgg from '../../../../assets/frontend/js/easterEggs/SearchEasterEgg'
import NoResults from './NoResults'
import type { PreparedLocationHit } from '../types'

type ListProps = {
  items: PreparedLocationHit[]
  isLastPage: boolean
  showMore: () => void
}

function List({ items, isLastPage, showMore }: ListProps) {
  const store = useAppStore()

  const displayMap = useAppSelector((state) => state.filter.displayMap)

  const onShowOnMap = useCallback(
    (hit: BaseHit) => {
      const lat = hit._geoloc?.lat ?? 0
      const lng = hit._geoloc?.lng ?? 0
      if (lat === 0 || lng === 0) {
        return
      }
      store.dispatch(
        filterActions.setLocation({
          lat,
          lng
        })
      )
      store.dispatch(filterActions.setDisplayMap(true))
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'location_finder_select',
        location_name: t(hit.name, { fallback: 'any' }),
        location_id: hit.objectID
      });
    },
    [store]
  )

  if (items.length === 0) {
    return (
      <>
        <SearchEasterEgg source="location-finder" noResults />
        <NoResults />
      </>
    )
  }

  return (
    <div>
      <SearchEasterEgg source="location-finder" noResults={false} />
      <div className="grid g-3">
        {items.map((item) => (
          <div
            key={item.objectID}
            className={classNames(
              'g-col-12',
              displayMap ? 'g-col-xl-6' : 'g-col-md-6 g-col-xl-4'
            )}
          >
            <CardHitComponent hit={item} onShowOnMap={onShowOnMap} />
          </div>
        ))}
      </div>
      {!isLastPage && (
        <div className="text-center mt-2">
          <button type="button" className="btn btn-default" onClick={showMore}>
            {_x('Show more', 'Location Finder List Show More Button', 'icf')}
          </button>
        </div>
      )}
    </div>
  )
}

export default List
